import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdb66f62"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "EventsCard__Background" }, null, -1))
const _hoisted_2 = { class: "EventsCard__Inner" }
const _hoisted_3 = { class: "EventsCard__Left" }
const _hoisted_4 = { class: "EventsCard__Right" }
const _hoisted_5 = { class: "place" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "EventsCard__Booked",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-booked" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "EventsCard__Booked --hover",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-booked-hover" })
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "EventsCard__Booked",
  viewBox: "0 0 32 32"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventsDate = _resolveComponent("EventsDate")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/events/${_ctx.event.id}`,
    class: _normalizeClass(["EventsCard", { 'current': _ctx.selectedEvent?.id === _ctx.event.id }])
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_EventsDate, {
            class: "EventsCard__Left__Date",
            date: _ctx.event.start_date
          }, null, 8, ["date"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.event.city), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.formattedTime), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.event.timezone), 1)
          ])
        ]),
        _createVNode(_Transition, { name: "booked" }, {
          default: _withCtx(() => [
            (_ctx.event.can_register==='registered')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
              : (_openBlock(), _createElementBlock("svg", _hoisted_11))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}